import { defineComponent } from 'vue';
export default defineComponent({
    name: 'SlideShowTopBar',
    props: {
        isGridView: { type: Boolean },
        isLightboxView: { type: Boolean },
        route: { type: Object, default: () => ({}) },
    },
    emits: ['toggle-grid-view', 'toggle-lightbox'],
});
